<div class="member-component-wrapper">
  <div class="container-fluid">
    <div class="row">
      <div class="col-xs-12 col-md-6 col-lg-4">
        <div class="card card-style-1">
          <div class="card-body">
            <div class="card-title row justify-content-between align-items-center">
              <h4 class="m-0 header-title">My Profile</h4>
            </div>
            <div class="row">
              <div class="col-12">
                <ul class="inner-cards profile-details mt-2 ml-2 mr-2">
                  <span>Select your policy</span>
                  <li class="mt-0">
                    <div class="form-group w-100 m-0">
                      <div class="dropdown card-header-dropdown mt-0">
                        <button
                          class="btn btn-sm dropdown-toggle"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="true"
                        >
                          <span *ngIf="currentPolicy.hasOwnProperty('policyId')" class="policy-content">
                            <span *ngIf="currentPolicy.isActive" class="logged"></span>
                            <span *ngIf="!currentPolicy.isActive" class="notLogged"></span>
                            <span
                              *ngIf="
                                currentPolicy.riskStartDate !== undefined &&
                                currentPolicy.onScreenDisplayAvailable == false
                              "
                            >
                              {{ currentPolicy.riskStartDate.split('-')[0] }}-{{
                                currentPolicy.riskEndDate.split('-')[0]
                              }}
                              - {{ currentPolicy.policyNumber }} - {{ currentPolicy.policyType }}</span
                            >
                            <span
                              *ngIf="
                                currentPolicy.riskStartDate !== undefined &&
                                currentPolicy.onScreenDisplayAvailable == true
                              "
                              >{{ currentPolicy.onScreenDisplayPolicy }}</span
                            >
                          </span>
                        </button>
                        <div class="dropdown-menu dropdown-menu-right">
                          <div *ngFor="let policy of policies" (click)="onNamePolicyChanged(policy)">
                            <a class="dropdown-item">
                              <span *ngIf="policy.isActive" class="logged"></span>
                              <span *ngIf="!policy.isActive" class="notLogged"></span>
                              <span *ngIf="policy.onScreenDisplayAvailable == false">
                                {{ policy.riskStartDate.split('-')[0] }}-{{ policy.riskEndDate.split('-')[0] }} -
                                {{ policy.policyNumber }} - {{ policy.policyType }}</span
                              >
                              <span *ngIf="policy.onScreenDisplayAvailable == true">{{
                                policy.onScreenDisplayPolicy
                              }}</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
                <ul class="list-unstyled shimmer-wrapper" *ngIf="!ismemberLoaded && !isHrView">
                  <li class="shimmer"></li>
                  <li class="shimmer"></li>
                  <li class="shimmer"></li>
                  <li class="shimmer"></li>
                  <li class="shimmer"></li>
                  <li class="shimmer"></li>
                </ul>
                <ul
                  class="inner-cards profile-details"
                  *ngIf="isEmployeeBelongsToPolicy && ismemberLoaded && !isHrView"
                >
                  <li>
                    <span class="field-name mr-2">Name:</span>
                    <span class="field-data">{{ memberSelf.insuredName }}</span>
                  </li>
                  <li>
                    <span class="field-name mr-2">Mobile:</span>
                    <span class="field-data">{{ memberSelf.mobileNo }}</span>
                  </li>
                  <li class="w-100">
                    <span class="field-name mr-2">Email:</span>
                    <span class="field-data">{{ memberSelf.emailID }}</span>
                  </li>
                  <li class="w-100" *ngIf="!isMobileView">
                    <span class="field-name mr-2">Address:</span>
                    <span class="field-data">{{ memberSelf.address1 }} </span>
                  </li>
                  <li class="w-100" *ngIf="!isMobileView">
                    <span class="field-name mr-2">Date of Joining:</span>
                    <span class="field-data">{{ formatDoj(memberSelf.doj) }} </span>
                  </li>
                  <li class="w-100" *ngIf="!isMobileView">
                    <span class="field-name mr-2">Employee ID:</span>
                    <span class="field-data">{{ memberSelf.memberIdEmpId }} </span>
                  </li>
                  <li class="w-100">
                    <span class="field-name mr-2">Abha ID:</span>
                    <span class="field-data">{{ memberSelf.insuredABHAId }}</span>
                  </li>
                  <li class="w-100">
                    <span class="field-name mr-2">Abha Address:</span>
                    <span class="field-data">{{ memberSelf.insuredABHAAddress }}</span>
                  </li>
                  <li class="w-100" *ngIf="!isMobileView">
                    <span class="field-name mr-2">Relationship:</span>
                    <span class="field-data">Self </span>
                  </li>
                  <li class="w-100" *ngIf="!isMobileView">
                    <span class="field-name mr-2">Age:</span>
                    <span class="field-data">{{ memberSelf.age }} Years </span>
                  </li>
                  <li class="w-100" *ngIf="isMobileView && productCode!=='2914'">
                    <div class="d-flex justify-content-around">
                      <p (click)="showEcard()">View E-Card</p>
                      <p (click)="downloadECard()">Download E-Card</p>
                    </div>
                    <div style="width: 100%; height: 100px;" *ngIf="showECardPreview && productCode!=='2914'">
                      <pdf-viewer [src]="base64Str" [show-all]="true" [original-size]="false" [zoom]="1.0"></pdf-viewer>
                    </div>
                  </li>
                </ul>
                <ul class="list-unstyled shimmer-wrapper" *ngIf="!ishrProfileLoaded && isHrView">
                  <li class="shimmer"></li>
                  <li class="shimmer"></li>
                  <li class="shimmer"></li>
                </ul>
                <ul class="inner-cards profile-details" *ngIf="ishrProfileLoaded && isHrView">
                  <li>
                    <span class="field-name mr-2">Name:</span>
                    <span class="field-data">{{ hrProfile.name }}</span>
                  </li>
                  <li>
                    <span class="field-name mr-2">Mobile:</span>
                    <span class="field-data">{{ hrProfile.mobileNo }}</span>
                  </li>
                  <li class="w-100">
                    <span class="field-name mr-2">Email:</span>
                    <span class="field-data">{{ hrProfile.email }}</span>
                  </li>
                  <li class="w-100">
                    <span class="field-name mr-2">Date of Joining:</span>
                    <span class="field-data">{{ memberDoj }} </span>
                  </li>
                  <li class="w-100">
                    <span class="field-name mr-2">Employee ID:</span>
                    <span class="field-data">{{ hrProfile.hrEmpId }} </span>
                  </li>
                  <li class="w-100">
                    <span class="field-name mr-2">Address:</span>
                    <span class="field-data">{{ memberSelf.address1 }} </span>
                  </li>
                  <li class="w-100">
                    <span class="field-name mr-2">Abha ID:</span>
                    <span class="field-data">{{ memberSelf.insuredABHAId }}</span>
                  </li>
                  <li class="w-100">
                    <span class="field-name mr-2">Abha Address:</span>
                    <span class="field-data">{{ memberSelf.insuredABHAAddress }}</span>
                  </li>
                  <li class="w-100">
                    <span class="field-name mr-2">Relationship:</span>
                    <span class="field-data">Self </span>
                  </li>
                  <li class="w-100">
                    <span class="field-name mr-2">Age:</span>
                    <span class="field-data">{{ memberAge }} Years </span>
                  </li>
                  <li class="w-100">
                    <span class="field-name mr-2">Covered Up-to Sum Insured:</span>
                    <span class="field-data">{{ coveredUptoSumInsured }} </span>
                  </li>
                </ul>
              </div>
            </div>
            <!-- end row -->
          </div>
        </div>
      </div>

      <div class="col-xs-12 col-md-6 col-lg-4">
        <div class="card card-style-1">
          <div class="card-body depedent-details" *ngIf="isHr && isHrView">
            <div class="card-title row justify-content-between align-items-center">
              <h4 class="m-0 header-title">
                Policy Details
              </h4>
            </div>
            <div class="row">
              <div class="col-md-12">
                <ul class="list-unstyled shimmer-wrapper" *ngIf="!isPolicyInfoLoaded">
                  <li class="shimmer"></li>
                  <li class="shimmer"></li>
                  <li class="shimmer"></li>
                  <li class="shimmer"></li>
                </ul>
                <ul class="policy-infocards" *ngIf="isPolicyInfoLoaded">
                  <li>
                    <span class="field-data">
                      Active Insured
                      <strong>{{ policyInfo.activeInsured }} </strong>
                    </span>
                  </li>
                  <li>
                    <span class="field-data">
                      Total Endorsements
                      <strong>{{ policyInfo.totalEndorsements }} </strong>
                    </span>
                  </li>
                  <li>
                    <span class="field-data">
                      Cashless Claims
                      <strong>{{ policyInfo.cashlessClaims }} </strong>
                    </span>
                  </li>
                  <li>
                    <span class="field-data">
                      Reimbursement Claims
                      <strong>{{ policyInfo.reimbursementClaims }} </strong>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <!-- end row -->
          </div>

          <!-- end card -->
          <div class="card-body depedent-details" *ngIf="isEmployeeBelongsToPolicy && !isHrView">
            <div class="card-title row justify-content-between align-items-center">
              <h4 class="my-0 header-title">
                Policy Details
              </h4>
            </div>

            <div class="p-1" *ngIf="isDependentLoaded && dependent.length === 0 && productCode != '2914'">
              <h6 class="my-4">No Dependent Found!</h6>
              <p [routerLink]="'/cp-member/endorsement'">Add Member Details</p>
            </div>
            <div class="p-1" *ngIf="!isNomineeAvailable && productCode == '2914'">
              <h6 class="my-4">No Nominee Found!</h6>
              <p [routerLink]="'/cp-member/nominee-enroll'">Add Nominee Details</p>
            </div>
            <ul class="list-unstyled shimmer-wrapper" *ngIf="!isDependentLoaded || (productCode=='2914' && !isNomineeLoaded)">
              <li class="shimmer-row">
                <div class="image-shimmer"></div>
                <div class="shimmer"></div>
              </li>
              <li class="shimmer-row">
                <div class="image-shimmer"></div>
                <div class="shimmer"></div>
              </li>
              <li class="shimmer-row">
                <div class="image-shimmer"></div>
                <div class="shimmer"></div>
              </li>
              <li class="shimmer-row">
                <div class="image-shimmer"></div>
                <div class="shimmer"></div>
              </li>
            </ul>

            <div class="row" *ngIf="productCode!=='2914'">
              <div class="col-md-12">
                <ul class="inner-cards">
                  <li *ngFor="let dep of dependent">                    
                    <img
                      *ngIf="dep.relationShipId === 'SELF' && dep.sex === 'M'"
                      class="d-flex align-self-start rounded mr-3"
                      src="assets/images/husband.png"
                      alt="Generic placeholder image"
                      height="64"
                    />
                    <img
                      *ngIf="dep.relationShipId === 'SELF' && dep.sex === 'F'"
                      class="d-flex align-self-start rounded mr-3"
                      src="assets/images/wife.png"
                      alt="Generic placeholder image"
                      height="64"
                    />
                    <img
                      *ngIf="dep.relationShipId === 'SPOUSE' && dep.sex === 'M'"
                      class="d-flex align-self-start rounded mr-3"
                      src="assets/images/husband.png"
                      alt="Generic placeholder image"
                      height="64"
                    />
                    <img
                      *ngIf="dep.relationShipId === 'SPOUSE' && dep.sex === 'F'"
                      class="d-flex align-self-start rounded mr-3"
                      src="assets/images/wife.png"
                      alt="Generic placeholder image"
                      height="64"
                    />
                    <img
                      *ngIf="dep.relationShipId === 'SON'"
                      class="d-flex align-self-start rounded mr-3"
                      src="assets/images/son.png"
                      alt="Generic placeholder image"
                      height="64"
                    />
                    <img
                      *ngIf="dep.relationShipId === 'DAUGHTER'"
                      class="d-flex align-self-start rounded mr-3"
                      src="assets/images/daughter.png"
                      alt="Generic placeholder image"
                      height="64"
                    />
                    <img
                      *ngIf="dep.relationShipId === 'FATHER'"
                      class="d-flex align-self-start rounded mr-3"
                      src="assets/images/father.png"
                      alt="Generic placeholder image"
                      height="64"
                    />
                    <img
                      *ngIf="dep.relationShipId === 'MOTHER'"
                      class="d-flex align-self-start rounded mr-3"
                      src="assets/images/mother.png"
                      alt="Generic placeholder image"
                      height="64"
                    />
                    <span class="field-data"
                      >{{ dep.insuredName || dep.name 
                      }}<small>
                        <strong>{{ dep.relationShipId }} - </strong> {{ dep.age }} Years</small
                      ></span
                    >
                  </li>
                </ul>
              </div>
            </div>

            <div class="row" *ngIf="productCode=='2914' && isNomineeAvailable">
              <div class="col-md-12">
                <ul class="inner-cards">
                  <li *ngFor="let nom of nominee">                    
                    <img
                      *ngIf="nom.relationship.toLowerCase() == 'SELF'.toLowerCase() && nom.sex === 'Male'"
                      class="d-flex align-self-start rounded mr-3"
                      src="assets/images/husband.png"
                      alt="Generic placeholder image"
                      height="64"
                    />
                    <img
                      *ngIf="nom.relationship.toLowerCase() == 'SELF'.toLowerCase() && nom.sex === 'Female'"
                      class="d-flex align-self-start rounded mr-3"
                      src="assets/images/wife.png"
                      alt="Generic placeholder image"
                      height="64"
                    />
                    <img
                      *ngIf="nom.relationship.toLowerCase() == 'SPOUSE'.toLowerCase() && nom.sex === 'Male'"
                      class="d-flex align-self-start rounded mr-3"
                      src="assets/images/husband.png"
                      alt="Generic placeholder image"
                      height="64"
                    />
                    <img
                      *ngIf="nom.relationship.toLowerCase() == 'SPOUSE'.toLowerCase() && nom.sex === 'Female'"
                      class="d-flex align-self-start rounded mr-3"
                      src="assets/images/wife.png"
                      alt="Generic placeholder image"
                      height="64"
                    />
                    <img
                      *ngIf="nom.relationship.toLowerCase() == 'SON'.toLowerCase()"
                      class="d-flex align-self-start rounded mr-3"
                      src="assets/images/son.png"
                      alt="Generic placeholder image"
                      height="64"
                    />
                    <img
                      *ngIf="nom.relationship.toLowerCase() == 'DAUGHTER'.toLowerCase()"
                      class="d-flex align-self-start rounded mr-3"
                      src="assets/images/daughter.png"
                      alt="Generic placeholder image"
                      height="64"
                    />
                    <img
                      *ngIf="nom.relationship.toLowerCase() === 'FATHER'.toLowerCase()"
                      class="d-flex align-self-start rounded mr-3"
                      src="assets/images/father.png"
                      alt="Generic placeholder image"
                      height="64"
                    />
                    <img
                      *ngIf="nom.relationship.toLowerCase() === 'MOTHER'.toLowerCase()"
                      class="d-flex align-self-start rounded mr-3"
                      src="assets/images/mother.png"
                      alt="Generic placeholder image"
                      height="64"
                    />
                    <span class="field-data"
                      >{{ nom.name 
                      }}<small>
                        <strong>{{ nom.relationship }} - </strong> {{ nom.age }} Years</small
                      ></span
                    >
                  </li>
                </ul>
              </div>
            </div>
            <!-- end row -->
          </div>
        </div>

        <div class="card card-style-1" *ngIf="currentPolicy.policyNote">
          <div class="card-body p-4 text-danger">
            Please reach out to HR for any changes to your name, date of birth, or mobile number.
          </div>
        </div>
      </div>

      <div class="col-xs-12 col-md-6 col-lg-4">
        <div class="card card-style-1">

          <!-- end card -->
          <div class="card-body depedent-details" *ngIf="isEmployeeBelongsToPolicy && !isHrView &&  (policyNumber==='110332528120000033' || policyNumber==='110332429140000003')  ">
            <div class="card-title row justify-content-between align-items-center">
              <h4 class="my-0 header-title">
                <span *ngIf=" productCode!=='2914'">Network Hospitals / </span>  Policy Benefits
              </h4>
            </div>
            <div class="p-1 mt-4">
              <p *ngIf=" productCode!=='2914'" class="text-underline-offset">
                <a href="https://rgi-locator.appspot.com/?Search_by=hospital&sourcesystem=corporateportal&phonenumber=&emailid=#/" 
                 target="_blank">Network Hospital List</a>
              </p>
              <p class="text-underline-offset">
                <a
                  data-toggle="modal"
                  data-target="#policyBenefit_Popup">
                  Policy Benefit Document</a>
              </p>
            </div>
            <!-- end row -->
          </div>
        </div>

      </div>

      <div class="col-xs-12 col-lg-4">
        <div class="card w-100">
          <div class="card-body p-0">
            <img src="/assets/images/offerblock.png" width="100%" alt="" />
          </div>
        </div>
        <div class="card w-100">
          <div class="card-body p-0">
            <ul class="comp-logos">
              <li title="Health O Pedia" *ngIf="currentPolicy.healthOPedia">
                <a href="https://www.reliancegeneral.co.in/insurance/knowledge-center.aspx" target="_blank">
                  <img src="/assets/images/health_o_pedia.png" alt="" />
                </a>
              </li>
              <li title="R Health Beat" *ngIf="currentPolicy.rHealthBeat">
                <a href="https://www.reliancegeneral.co.in/insurance/insurance-information/wellness/r-healthbeat.aspx?hA00MEt" target="_blank">
                  <img src="/assets/images/r_health_beat.png" alt="" />
                </a>
              </li>
              <li (click)="generateSSO()" title="R Health Assist" *ngIf="currentPolicy.rHealthAssist">
                <img src="/assets/images/wellnessImg.png" alt="" />
              </li>
              
              <li *ngIf="currentPolicy.valueDeals" >
                <a href="https://www.reliancegeneral.co.in/insurance/insurance-information/wellness/value-deals.aspx?wellness=Wellness" target="_blank" title="Value Deals">
                  <img src="/assets/images/value_deals.png" alt="" />
                </a>
              </li>
              <li *ngIf="currentPolicy.hra">
                <a href="https://www.reliancegeneral.co.in/insurance/self-help/intimatehra.aspx?PID=9" target="_blank" title="Health Risk Assessment">
                  <img src="/assets/images/HRA.png" alt="" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="card w-100">
          <div class="card-body card-inverted-blue">
            <div class="card-title row justify-content-between align-items-center">
              <h4 class="m-0 header-title">
                Looking for general insurance products
                <hr />
              </h4>
            </div>
            <div class="row">
              <div class="col-md-12" >
                <ul class="general-insurance-product pr-15">
                  <li >
                    <span class="icon">
                      <img src="/assets/images/health-home.png" alt="" />
                    </span>
                    <span class="icon-title">
                      Health
                    </span>
                  </li>
                  <li>
                    <span class="icon">
                      <img src="/assets/images/home.png" alt="" />
                    </span>
                    <span class="icon-title">
                      Home
                    </span>
                  </li>
                  <li>
                    <span class="icon">
                      <img src="/assets/images/motor.png" alt="" />
                    </span>
                    <span class="icon-title">
                      Motor
                    </span>
                  </li>
                  <li>
                    <span class="icon">
                      <img src="/assets/images/travel.png" alt="" />
                    </span>
                    <span class="icon-title">
                      Travel
                    </span>
                  </li>
                  <li>
                    <span class="icon">
                      <img src="/assets/images/sme.png" alt="" />
                    </span>
                    <span class="icon-title">
                      SME
                    </span>
                  </li>
                  <li>
                    <span class="icon">
                      <img src="/assets/images/other.png" alt="" />
                    </span>
                    <span class="icon-title">
                      Others
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <!-- end row -->
          </div>
        </div>

        <!-- <div class="card w-100" *ngIf="!isHrView">
          <div class="card-body bg-blue p-1">
            <div class="row">
              <div class="col-md-12">
                <ul class="comp-logos">
                  <li *ngIf="currentPolicy.rHealthAssist">
                    <a [href]="rhealthAssist" target="_blank"> <img src="/assets/images/rha.jpg" alt=""/></a>
                  </li>
                  <li *ngIf="currentPolicy.rHealthCircle">
                    <a [href]="rhealthCircle" target="_blank"> <img src="/assets/images/logo-2.jpg" alt=""/></a>
                  </li>
                  <li *ngIf="currentPolicy.healthOPedia">
                    <a href="https://www.reliancegeneral.co.in/Insurance/Self-Help/Health-O-Pedia.aspx" target="_blank">
                      <img src="/assets/images/Health-o-pedias.png" alt=""
                    /></a>
                  </li>
                  <li *ngIf="currentPolicy.rHealthBeat">
                    <a
                      href="https://www.reliancegeneral.co.in/Insurance/Insurance-Information/Wellness/R-HealthBeat.aspx"
                      target="_blank"
                    >
                      <img src="/assets/images/RhealthBeat.jpg" alt=""
                    /></a>
                  </li>
                  <li *ngIf="currentPolicy.valueDeals">
                    <a
                      href="https://www.reliancegeneral.co.in/Insurance/Insurance-Information/Wellness/Value-Deals.aspx"
                      target="_blank"
                    >
                      <img src="/assets/images/offer-bags.jpg" alt=""
                    /></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</div>

<!-- Policy Benefit Document Popup -->
  <div
    class="modal fade"
    id="policyBenefit_Popup"
    tabindex="-1"
    role="dialog"
    aria-labelledby="policyBenefit_Popup"
    aria-hidden="true"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-dialog-scrollable modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Policy Benefit <small></small></h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body policyBenefit_Popup">
          <table align="center" data-module="1-1-panel-1" data-bgcolor="Main BG" mc:repeatable="layout" mc:hideable=""
          mc:variant="1/1 panel 1" class="" width="100%" cellspacing="0" cellpadding="0" border="0" bgcolor="#F8F8F8">
          <tr>
            <td align="center">
      
              <table align="center" data-bgcolor="Boxed"
                style="max-width: 700px; width: 700px;  margin: 0 auto 20px; text-align: center;" class="table-inner"
                width="700" cellspacing="0" cellpadding="0" border="0" bgcolor="#fff">
      
                <tr>
                  <td align="center">
      
      
                    <table align="center" width="650" class="full-width"
                      style="max-width:700px; width:100%; padding: 0px 0;margin: 0 auto" border="0" cellspacing="0"
                      cellpadding="0">
                      <tr>
                        <td>
      
                        </td>
                      </tr>
      
                    </table>
                  </td>
                </tr>
                <tr>
                  <td align="center">
                    <table align="center" width="100%" style="text-align: center;" border="0" cellpadding="0" cellspacing="0">
                      <tbody>
                        <tr>
                          <td width="100%" valign="middle"
                            style="font-family: Arial, sans-serif; color:#000000; text-align: center; line-height: 18px; margin-top: 10px; padding-bottom: 0%;"
                            data-link-style="text-decoration:none; color:#f9ac1d;" data-link-color="Content Link"
                            data-size="Content" data-color="Content" mc:edit="modulo-88">
      
                            <table style="display: inline-block; border-spacing: 0;" border="0" cellpadding="0"
                              cellspacing="0">
                              <tbody>
                                <tr>
                                  <td data-link-style="text-decoration:none;" data-link-color="Content Link"
                                    data-size="Content" data-color="Content" mc:edit="modulo-88">
                                    <img src="https://www.reliancegeneral.co.in/SiteAssets/MCOM/top_logo010725.jpg" width="700" style="max-width: 100%;">
      
                                  </td>
      
      
                                </tr>
      
                             
      
                                <tr>
                                  <td style="">
                                    <table width="100%" border="0" cellpadding="0" cellspacing="0">
                                      <tbody>
                                        <tr>
                                          <td data-link-style="text-decoration:none;" data-link-color="Content Link"
                                            data-size="Content" data-color="Content" mc:edit="modulo-88" style="">
                                           <img src="https://www.reliancegeneral.co.in/SiteAssets/MCOM/content010725.jpg" width="700" style="max-width: 100%;">
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
      
                                <tr>
                                  <td style="">
                                    <table width="100%" border="0" cellpadding="0" cellspacing="0">
                                      <tbody>
                                        <tr>
                                          <td data-link-style="text-decoration:none;" data-link-color="Content Link"
                                            data-size="Content" data-color="Content" mc:edit="modulo-88" style="">
                                            <img src="https://www.reliancegeneral.co.in/SiteAssets/MCOM/footer010725.jpg" width="700" style="max-width: 100%;">
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
      
                              </tbody>
                            </table>
                          </td>
      
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
      
                <tr>
                  <td style="background-color:#edeeee; margin-top: 20px;">
                    <table width="94%" style="background-color:#edeeee; margin-top: 0px;" border="0" cellpadding="0"
                      cellspacing="0">
                      <tbody>
                        <tr>
                          <td valign="middle"
                            style="font-family:Arial, sans-serif; font-size:14px;font-weight: 400;line-height: 14px; text-align: left; padding-top: 10px;"
                            data-link-style="text-decoration:none; color:#f9ac1d;" data-link-color="Content Link"
                            data-size="Content" data-color="Content" mc:edit="modulo-88">
      
                            <div class="footer-text-header"
                              style="font-family:Arial, sans-serif; color:#231f20; font-size:13px;font-weight: 700;line-height: 22px; text-align: justify; margin-top: 0px; margin-bottom: 0px; padding-bottom: 5px;">
                              reliancegeneral.co.in | 022 4890 3009 (Paid) | 74004 22200 (WhatsApp)
                            </div>
                            <div class="footer-text-body"
                              style="font-family:Arial, sans-serif; color:#231f20; font-size:12px;font-weight: 400;line-height: 22px; text-align: justify; margin-top: 0px; margin-bottom: 0px; padding-bottom: 10px;">                       
                                      
                              Group Mediclaim, UIN - RELHLGP21523V022021. Group Personal Accident, UIN - RELPAGP01001V010001. IRDAI Registration no 103. Reliance General Insurance Company Limited. Registered & Corporate Office: 6th Floor, Oberoi Commerz, International Business Park, Oberoi Garden City, Off. Western Express Highway, Goregaon (E), Mumbai- 400063. Corporate Identity Number: U66603MH2000PLC128300. Trade Logo displayed above belongs to Anil Dhirubhai Ambani Ventures Private Limited and is used by Reliance General Insurance Company Limited under License. RGI/CO/MCOM/SwiggyOnePager/VER.1.0/28052025
                              </div>
                          </td>
      
                        </tr>
      
                      </tbody>
                    </table>
                  </td>
                </tr>
      
              </table>
            </td>
      
          </tr>
        </table>
        </div>
      </div>
    </div>
  </div>